import { DefaultValue, atom } from "recoil";
import { setOrganisationId as setXeroOrganisationId } from "./services/XeroClient";
import { setOrganisationId as setPayrollOrganisationId } from "./services/PayrollClient";
import { setOrganisationId as setAppsOrganisationId } from "./services/AppsClient";
import { setOrganisationId as setZatcaOrganisationId } from "./services/ZatcaClient";

export const modalState = atom({
  key: 'modalState',
  default: false,
});

export const showHeaderState = atom({
  key: 'showHeaderState',
  default: true
})

export const collapsedSidebarState = atom({
  key: 'collapsedSidebarState',
  default: false
})


const localStorageEffect =
  (key) =>
  ({ setSelf, onSet }) => {
    const savedValue = localStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue) => {
      if (newValue instanceof DefaultValue) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
    });
  };

const updateXeroClientEffect = ({ onSet, setSelf }) => {
  setSelf((value) => {
    setXeroOrganisationId(value);
    setPayrollOrganisationId(value);
    setAppsOrganisationId(value);
    setZatcaOrganisationId(value);
    return value;
  });
  onSet((value) => {
    setXeroOrganisationId(value);
    setPayrollOrganisationId(value);
    setAppsOrganisationId(value);
    setZatcaOrganisationId(value);
  });
};

export const languageState = atom({
  key: "language",
  default: "en",
  effects_UNSTABLE: [localStorageEffect("hesaab/language")],
});

export const organisationIdState = atom({
  key: "organisationId",
  default: null,
  effects_UNSTABLE: [
    localStorageEffect("hesaab/organisationId"),
    updateXeroClientEffect,
  ],
});
